import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss']
})
export class CategoryListComponent implements OnInit {
  url = this.router.url.split('?')[0];
  @Input() categories;
  @Input() categoryParentId;
  @Output() change: EventEmitter<any> = new EventEmitter();
  mainCategories;
  categoryImageUrl;
  private storeDetails = {};
  private storeDetailsJson = {};
  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.storeDetails = this.activatedRoute.snapshot.data['store']['response']['data']['store'];
    this.storeDetailsJson = this.activatedRoute['snapshot']['data']['store']['response']['data']['store_json'];
    this.categoryImageUrl = environment.categoryImageUrl+this.storeDetails['id']+"/";
  }

  public ngDoCheck() {
    this.mainCategories = this.categories;
   
  }

  public stopClickPropagate(event: any){
    if(window.innerWidth < 960){
      event.stopPropagation();
      event.preventDefault();
    }    
  }

  public changeCategory(event, category, parentCategory){
    this.change.emit({event, category, parentCategory});
  }

}